
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Image,
  IconButton,
  Text,
  Table,
  Tbody,
  Tr,
  Td,
  HStack,
  Flex,
  Spinner,
  Box,
  Thead,
  Th,
  Button,
  Select,
  useToast,
  Input,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { FiPlus, FiMinus, FiTrash, FiSearch } from "react-icons/fi";
import { useState, useEffect } from "react";
import API_CONFIG from "../../Configuration/apiConfig";
import apiClient from "../../Configuration/apiClient";
export default function EditImageModal({ isOpen, onClose, runId, storeId, fileName, onSave, preloadedImageUrl }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(!preloadedImageUrl);
  const [updating, setUpdating] = useState(false);
  const [currentActualPath, setCurrentActualPath] = useState(null);
  const [currentAnnotatedPath, setCurrentAnnotatedPath] = useState(null);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [addingproduct, setAddingProduct] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const toast = useToast({
    position: "top"
  });

  const generatePresignedUrl = async (s3Path, month, year) => {
    const presignedEndpoint = `https://s3service.sconexsoft.com/s3bucket/presigned-url?fileName=${encodeURIComponent(
      s3Path
    )}&bucketName=imageinsightimagesbeverages&operation=download&month=${month}&year=${year}&ResponseContentDisposition=attachment`;

    try {
      const response = await fetch(presignedEndpoint);
      if (!response.ok) throw new Error("Failed to fetch presigned URL");
      const presignedUrl = await response.text();
      return presignedUrl.trim();
    } catch (err) {
      console.error("Failed to generate presigned URL:", err);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (isOpen && runId && storeId && fileName) {
        setLoading(true);
        setImageLoading(false);

        try {
          const response = await apiClient.get(
            `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.STORE_REPORT.GET_PRODUCTS}`,
            {
              params: {
                runId: runId,
                storeId: storeId,
                fileName: fileName
              }
            }
          );

          const runTimeStamp = new Date(response.data.batchMaster.runTimeStamp);
          const month = runTimeStamp.getMonth() + 1;
          const year = runTimeStamp.getFullYear();

          const actualPath = response.data.batchTransactions[0]?.s3pathActualFile;
          const annotatedPath = response.data.batchTransactions[0]?.s3pathAnnotatedFile;

          setCurrentActualPath(actualPath);
          setCurrentAnnotatedPath(annotatedPath);
          setImageLoading(true);

   
         const imageUrl = preloadedImageUrl || await generatePresignedUrl(actualPath, month, year);
         if (preloadedImageUrl) {
             setImageLoading(false);
      }



          const imageData = {
            imageUrl: imageUrl,
            fileName: response.data.batchMaster.fileName,
            ss3pathAnnotatedFile: annotatedPath,
            products: response.data.batchTransactions.map(tx => ({
              productId: tx.product.productId,
              name: tx.product.productName,
              companyName: tx.product.productCompany?.productCompanyName,
              brand: tx.product.productBrand?.productBrandName,
              packType: tx.product.packType,
              size: tx.product.packSize,
              count: tx.productCount
            }))
          };

          setData([imageData]);
          setLoading(false);
        } catch (err) {
          console.error('Error:', err);
          setLoading(false);
          setImageLoading(false);
        }
      }
    };

    fetchData();
  }, [isOpen, runId, storeId, fileName]);

  useEffect(() => {
    const fetchAvailableProducts = async () => {
      try {
        const response = await apiClient.get(
          `${API_CONFIG.BASE_URL}/status/availability-products`
        );
        setAvailableProducts(response.data);
      } catch (err) {
        console.error('Error fetching products:', err);
        toast({
          title: "Error fetching products",
          description: "Could not load available products",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };
    if (isOpen) {
      fetchAvailableProducts();
    }
  }, [isOpen, toast]);

  const handleIncrement = (index) => {
    setData(prevData => {
      const newData = [...prevData];
      newData[0].products[index].count += 1;
      return newData;
    });
  };

  const handleDecrement = (index) => {
    setData(prevData => {
      const newData = [...prevData];
      if (newData[0].products[index].count > 0) {
        newData[0].products[index].count -= 1;
      }
      return newData;
    });
  };

  const handleDelete = async (index) => {
    const productToDelete = data[0].products[index];

    if (!window.confirm(`Are you sure you want to delete ${productToDelete.name}?`)) {
      return;
    }

    try {
      await apiClient.delete(
        `${API_CONFIG.BASE_URL}/batch-transactions/delete-product`,
        {
          data: {
            runId: runId,
            storeId: storeId,
            fileName: fileName,
            product: {
              productId: productToDelete.productId,
              productName: productToDelete.name,
              packType: productToDelete.packType,
              packSize: productToDelete.size,
              productCompany: productToDelete.companyName ? {
                productCompanyName: productToDelete.companyName
              } : undefined,
              productBrand: productToDelete.brand ? {
                productBrandName: productToDelete.brand
              } : undefined
            }
          }
        }
      );

      setData(prevData => {
        const newData = [...prevData];
        newData[0].products.splice(index, 1);

        if (newData[0].products.length === 0) {
          toast({
            title: "All products deleted",
            description: "Batch master removed.",
            status: "info",
            duration: 3000,
            isClosable: true,
          });
          onClose();
        } else {
          toast({
            title: "Product deleted",
            description: "Product deleted successfully!",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        }

        return newData;
      });

    } catch (err) {
      console.error('Delete failed:', err);
      console.error('Error details:', err.response?.data);
      toast({
        title: "Delete failed",
        description: "Failed to delete product",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleAddProduct = async () => {
    if (!selectedProductId) {
      toast({
        title: "No product selected",
        description: "Please select a product to add",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const productExists = data[0].products.some(
      p => p.productId === selectedProductId
    );

    if (productExists) {
      toast({
        title: "Product already exists",
        description: "This product is already in the list",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setAddingProduct(true);

    try {
      const selectedProduct = availableProducts.find(
        p => p.productId === selectedProductId
      );
      const requestBody = {
        runId: runId,
        storeId: storeId,
        fileName: fileName,
        product: {
          productId: selectedProduct.productId,
          productName: selectedProduct.productName,
          packType: selectedProduct.packType,
          packSize: selectedProduct.packSize,
          productCompany: selectedProduct.productCompany ? {
            productCompanyID: selectedProduct.productCompany.productCompanyID,
            productCompanyName: selectedProduct.productCompany.productCompanyName
          } : undefined,
          productBrand: selectedProduct.productBrand ? {
            productbrandId: selectedProduct.productBrand.productbrandId,
            productBrandName: selectedProduct.productBrand.productBrandName
          } : undefined
        },
        productCount: 1,
        s3pathActualFile: currentActualPath,
        s3pathAnnotatedFile: currentAnnotatedPath
      };

      await apiClient.post(
        `${API_CONFIG.BASE_URL}/batch-transactions/add-product`,
        requestBody
      );

      const newProduct = {
        productId: selectedProduct.productId,
        name: selectedProduct.productName,
        companyName: selectedProduct.productCompany?.productCompanyName || null,
        brand: selectedProduct.productBrand?.productBrandName || null,
        packType: selectedProduct.packType || null,
        size: selectedProduct.packSize || 0,
        count: 1
      };

      setData(prevData => {
        const newData = [...prevData];
        newData[0].products.push(newProduct);
        return newData;
      });

      setSelectedProductId("");
      setSearchTerm("");

      toast({
        title: "Product added",
        description: `${selectedProduct.productName} added successfully`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });

    } catch (err) {
      console.error('Add product failed:', err);

      if (err.response?.data?.message?.includes('duplicate')) {
        toast({
          title: "Duplicate product",
          description: "This product already exists in the batch",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Add failed",
          description: err.response?.data?.message || "Failed to add product",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } finally {
      setAddingProduct(false);
    }
  };

  const handleUpdate = async () => {
    setUpdating(true);

    try {
      const batchTransactions = data[0].products.map(product => ({
        runId: runId,
        storeId: storeId,
        fileName: fileName,
        product: {
          productId: product.productId
        },
        productCount: product.count,
        s3pathActualFile: currentActualPath,
        s3pathAnnotatedFile: currentAnnotatedPath
      }));

      const batchMaster = {
        runId: runId,
        storeId: storeId,
        fileName: fileName
      };

        await apiClient.put(
        `${API_CONFIG.ENDPOINTS.STORE_REPORT.UPDATE}`,
        {
          batchTransactions: batchTransactions,
          batchMaster: batchMaster
        }
      );

      toast({
        title: "Update successful",
        description: "Batch transaction updated successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setUpdating(false);
      onClose();

      if (onSave) {
        await onSave();
      }

    } catch (err) {
      console.error('Update failed:', err);
      toast({
        title: "Update failed",
        description: "Failed to update batch transaction",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setUpdating(false);
    }
  };

  const filteredProducts = searchTerm
    ? availableProducts.filter(product =>
      product.productName.toLowerCase().includes(searchTerm.toLowerCase())
    )
    : availableProducts;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Image & Products</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6} overflow="visible">
              <Box mb={4}>
                {imageLoading && (
                  <Flex
                    justify="center"
                    align="center"
                    h="400px"
                    bg="gray.50"
                    borderRadius="lg"
                    border="1px"
                    borderColor="gray.200"
                  >
                    <Spinner size="xl" color="blue.500" thickness="4px" />
                    <Text ml={3} fontWeight="medium" color="gray.600">Loading image...</Text>
                  </Flex>
                )}
                { (preloadedImageUrl || data[0]?.imageUrl) &&(
                  <Image
                   src={preloadedImageUrl || data[0]?.imageUrl}
                    borderRadius="lg"
                    mb={4}
                    alt="Product Image"
                    onLoad={() => setImageLoading(false)}
                    onError={() => setImageLoading(false)}
                    display={imageLoading ? "none" : "block"}
                  />
                )}
                {!preloadedImageUrl && !imageLoading && !data[0]?.imageUrl && (
                <Text>Image not available</Text>
        )}
              </Box>
              {/* Searchable Product Dropdown */}
              {loading ?(
                <Flex justify="center" align="center" py={4}>
                  <Spinner size="md" color="blue.500"  />
                  <Text ml={3} color="gray.600">Loading products...</Text>
                </Flex>
              ):data.length===0?(
                <Text>No products data</Text>
              ):(
              <>
              <Box mb={4} p={4} bg="gray.50" borderRadius="md">
                <Text fontWeight="semibold" mb={2}>Add New Product</Text>
                <HStack align="flex-start">
                  <Box flex={1} position="relative">
                    <InputGroup>
                      <InputLeftElement pointerEvents="none">
                        <FiSearch color="gray.300" />
                      </InputLeftElement>
                      <Input
                        placeholder="Search products..."
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setShowDropdown(true);
                        }}
                        onFocus={() => setShowDropdown(true)}
                        onBlur={() => setShowDropdown(false)}
                        bg="white"
                      />
                    </InputGroup>
                    {showDropdown && filteredProducts.length > 0 && (
                      <Box
                        position="absolute"
                        top="100%"
                        left={0}
                        right={0}
                        bg="white"
                        border="1px"
                        borderColor="gray.200"
                        borderRadius="md"
                        mt={1}
                        maxH="250px"
                        overflowY="auto"
                        zIndex={999}
                        pointerEvents="auto"
                        boxShadow="lg"
                      >
                        {filteredProducts.map((product) => (
                          <Box
                            key={product.productId}
                            px={4}
                            py={2}
                            cursor="pointer"
                            _hover={{ bg: "blue.50" }}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              setSelectedProductId(product.productId);
                              setSearchTerm(product.productName);
                              setShowDropdown(false);
                            }}
                            borderBottom="1px"
                            borderColor="gray.100"
                          >
                            <Text fontWeight="medium">{product.productName}</Text>
                          </Box>
                        ))}
                      </Box>
                    )}
                    {showDropdown && searchTerm && filteredProducts.length === 0 && (
                      <Box
                        position="absolute"
                        top="100%"
                        left={0}
                        right={0}
                        bg="white"
                        border="1px"
                        borderColor="gray.200"
                        borderRadius="md"
                        mt={1}
                        zIndex={10}
                        boxShadow="lg"
                        px={4}
                        py={2}
                      >
                        <Text color="gray.500">No products found</Text>
                      </Box>
                    )}
                  </Box>
                  <Button
                    colorScheme="green"
                    onClick={handleAddProduct}
                    isDisabled={!selectedProductId}
                    isLoading={addingproduct}
                    leftIcon={<FiPlus />}
                  >
                    Add
                  </Button>
                </HStack>
              </Box>

              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th>Product</Th>
                    <Th>Company</Th>
                    <Th>Brand</Th>
                    <Th>Pack Type</Th>
                    <Th>Size</Th>
                    <Th>Count</Th>
                    <Th>Actions</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data[0].products.map((p, i) => (
                    <Tr key={i}>
                      <Td>{p.name}</Td>
                      <Td>{p.companyName || '-'}</Td>
                      <Td>{p.brand || '-'}</Td>
                      <Td>{p.packType || '-'}</Td>
                      <Td>{p.size || '0'}</Td>
                      <Td>
                        <HStack>
                          <IconButton icon={<FiMinus />} size="xs"
                            onClick={() => handleDecrement(i)}
                            isDisabled={p.count === 0} />
                          <Text>{p.count}</Text>
                          <IconButton icon={<FiPlus />} size="xs"
                            onClick={() => handleIncrement(i)} />
                        </HStack>
                      </Td>
                      <Td>
                        <IconButton icon={<FiTrash />} size="xs" colorScheme="red"
                          onClick={() => handleDelete(i)} />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleUpdate}
            isLoading={updating}
            loadingText="Updating..."
          >
            Update
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}